﻿import React, { useContext, useState, useEffect } from "react";
import moment from "moment";

import { WaitingListFlowContext } from "../WaitingListFlowContext";
import { validateFormObject } from "../Validation";
import { formatCurrency } from "../Currency";
// import { products, quote, payment } from "../Endpoints";
import { waitinglist } from "../../../_Shared/Scripts/Endpoints";
import { paramsToObject } from "../../../../../Resources/Scripts/_Shared/history";

import { BackNavigation } from "../partials/BackNavigation";
import { Lightbox } from "../partials/Lightbox";
import { List } from "../partials/List";
import { Error } from "../../../../../Resources/Scripts/_Shared/elements/Error";

import { CheckboxWithLabel } from "../../../../../Resources/Scripts/_Shared/elements/CheckboxWithLabel";
import Instructions from "../partials/Instructions";
import {
    hasWaitingListAttachment,
    isWaitingListAttachmentRequired,
    minuteToDays,
} from "../util";

const emptyGuid = "00000000-0000-0000-0000-000000000000";

const waitingListOverview = (props) => {
    const { waitingListFlowContext, setWaitingListFlowContext } = useContext(
        WaitingListFlowContext
    );
    const formLang = {
        ...waitingListFlowContext.episerver,
        ...waitingListFlowContext.localization.global.cost,
        ...waitingListFlowContext.localization.onlineBooking,
        ...waitingListFlowContext.localization.waitingListOverview,
    };

    const locale = waitingListFlowContext.country;

    const productSelection = waitingListFlowContext.product;

    const attachment = waitingListFlowContext.document?.fileMeta;
    const attachmentMissing =
        isWaitingListAttachmentRequired(waitingListFlowContext) &&
        !hasWaitingListAttachment(waitingListFlowContext);

    const paymentSelection =
        waitingListFlowContext?.paymentTerm?.paymentOption?.item;

    const vehiclesFormData = waitingListFlowContext.vehicle.formData;
    const vehicleLicensePlateNumbers =
        vehiclesFormData && vehiclesFormData.length > 0
            ? vehiclesFormData
                  .map((item) => item.PlateText.replace(/;/g, ""))
                  .join(";")
            : "";

    const numberOfSpots = 1;

    const zoneNameInfo =
        productSelection?.Zone !== waitingListFlowContext.facility.name
            ? productSelection?.Zone
            : null;
    const productDescription = productSelection?.Description ?? null;

    const paymentSelectionText = paymentSelection?.value
        ? formLang[paymentSelection?.value.toLowerCase()]
        : paymentSelection?.text;

    const listSelectionRows = [
        {
            left: formLang.facility,
            right: waitingListFlowContext.facility.name,
        },

        zoneNameInfo
            ? { left: formLang.zonename, right: productSelection.Zone }
            : {},

        {
            left: formLang.product,
            right: productSelection?.OverviewText ?? productSelection?.Text,
        },

        productDescription
            ? {
                  left: formLang.descriptionText,
                  right: productSelection?.Description,
              }
            : {},
        {
            left: formLang.price,
            right: `${productSelection?.MonthlyPrice} SEK`,
        },
        {
            left: formLang.payment,
            right:
                formLang.productType === 1
                    ? paymentSelectionText
                    : formLang.creditcard,
        },
        { left: formLang.numberOfParkingSpots, right: numberOfSpots },

        vehiclesFormData && vehiclesFormData.length > 0
            ? {
                  left:
                      vehiclesFormData.length > 1
                          ? formLang.vehicles
                          : formLang.vehicle,
                  right: vehicleLicensePlateNumbers.replace(/;/g, ", "),
                  class: "uppercase",
              }
            : {},
    ];

    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const [selectionRows, setSelectionRows] = useState(listSelectionRows);
    const [termsAndConditions, setTermsAndConditions] = useState({
        selected: false,
        required: true,
        elementType: "checkbox",
    });
    const [showCancelLightbox, setShowCancelLightbox] = useState(false);

    const closeCancelLightbox = () => {
        setShowCancelLightbox(false);

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete("responseCode");
        urlParams.delete("transactionId");
        urlParams.delete("qId");

        const newUrl =
            window.location.origin +
            window.location.pathname
                .replace("/PaymentResult", "/")
                .replace("//", "/") +
            "?" +
            urlParams.toString();

        history.pushState(paramsToObject(urlParams), document.title, newUrl);
    };

    const placeLtpOrderHandler = async () => {
        setPending(true);
        setError(null);

        if (attachmentMissing) {
            setError({
                error: true,
                errorText:
                    waitingListFlowContext.localization.uploadDocument
                        .requiredError,
                errorType: "registered",
            });
            setPending(false);
            return;
        }

        const newQuoteForm = {
            termsAndConditions: {
                value: termsAndConditions,
                setValue: setTermsAndConditions,
            },
        };

        let [formValidationError, cleanFormData] = validateFormObject(
            newQuoteForm,
            waitingListFlowContext.localization.global.errorMessages
        );
        if (formValidationError) {
            setPending(false);
            return;
        }

        const vehiclesFormData = waitingListFlowContext.vehicle.formData;

        const registered = await waitinglist.registerForWaitingList({
            pmcId: waitingListFlowContext.product.Id,
            countryCode: waitingListFlowContext.country.toUpperCase(),
            customerEmail: waitingListFlowContext.user.email,
            orderDetails: {
                quantity: 1,
                billingInterval:
                    waitingListFlowContext?.paymentTerm?.paymentOption?.item
                        ?.value || "MONTHLY",
                licensePlateNo:
                    vehiclesFormData && vehiclesFormData.length > 0
                        ? vehiclesFormData.map((item) => {
                              return item.PlateText.trim().split(" ").join("");
                          })[0]
                        : "",
                attachments: attachment?.uid
                    ? [
                          {
                              fileName: attachment.name,
                              mimeType: attachment.mimeType,
                              sizeBytes: attachment.sizeBytes,
                              uid: attachment.uid,
                          },
                      ]
                    : [],
            },
        });

        if (registered.status === 201) {
            setPending(false);

            setWaitingListFlowContext({
                ...waitingListFlowContext,
                activeStep: waitingListFlowContext.confirmation.index,
                overview: {
                    ...waitingListFlowContext.overview,
                    formData: {
                        ...cleanFormData,
                    },
                },
                confirmation: {
                    ...waitingListFlowContext.confirmation,
                    position: registered.body.Position,
                },
            });
        } else {
            setError({
                error: true,
                errorText:
                    registered.status === 403
                        ? "Waiting List is disabled"
                        : "Something went wrong! Please try again later!",
                errorType: "registered",
            });
            setPending(false);
        }
    };

    const instructions = [
        waitingListFlowContext.localization.global?.instructions?.overview
            ?.step1,
        waitingListFlowContext.localization.global?.instructions?.overview?.step2.replace(
            "[EMAIL]",
            waitingListFlowContext.user.email
        ),
        waitingListFlowContext.localization.global?.instructions?.overview?.step3.replace(
            "[X]",
            minuteToDays(
                waitingListFlowContext?.product?.ExpirationLimits
                    ?.WaitingListActivationPermitLock || 0
            )
        ),
    ];

    return (
        <div className="waitingListFlowPage__app waitingListFlowPage__app--waitingListOverview">
            <div className="single-step single-step--overview">
                {showCancelLightbox && (
                    <Lightbox onCloseEvent={closeCancelLightbox} close="Close">
                        <div className="single-step__lightbox__heading">
                            {formLang.paymentcancelled.heading}
                        </div>
                        <div className="single-step__lightbox__text">
                            {formLang.paymentcancelled.text}
                        </div>
                        <div className="single-step__lightbox__options">
                            <button
                                className="cancel"
                                onClick={() =>
                                    (window.location = formLang.completionLink)
                                }
                            >
                                {formLang.paymentcancelled.links.startpage}
                            </button>
                            <button onClick={closeCancelLightbox}>
                                {formLang.paymentcancelled.links.continue}
                            </button>
                        </div>
                    </Lightbox>
                )}

                <h2>
                    {
                        waitingListFlowContext.localization.waitingListOverview
                            .selectionHeading
                    }
                </h2>

                {/* <div>
                    <h3 className="center nomargin">
                        {(
                            formLang?.emailconformation?.description || ""
                        ).replace("X", waitingListFlowContext.user.email)}
                    </h3>
                    <p className="center margin italic">
                        {formLang.emailconformation.note}
                    </p>
                </div> */}

                <List rows={selectionRows} />

                <Instructions
                    title={
                        waitingListFlowContext.localization.global?.instructions
                            ?.overview?.title
                    }
                    instructions={instructions}
                    note={
                        waitingListFlowContext.localization.global?.instructions
                            ?.overview?.note
                    }
                />

                <h2>{formLang.termsandconditionsheading}</h2>
                <div className="single-step__checkbox-wrapper">
                    <div>
                        <CheckboxWithLabel
                            text={
                                formLang.productType === 1
                                    ? waitingListFlowContext.localization
                                          .createAccount.termsAndConditionsLTP
                                    : waitingListFlowContext.localization
                                          .createAccount.termsAndConditionsSTP
                            }
                            value={termsAndConditions}
                            setValue={setTermsAndConditions}
                        />
                    </div>
                </div>

                {error &&
                    error.errorText?.length > 0 &&
                    error.errorType === "registered" && (
                        <Error text={error.errorText} />
                    )}

                {attachmentMissing && (
                    <Error
                        text={
                            waitingListFlowContext.localization.uploadDocument
                                .requiredError
                        }
                    />
                )}
                <div className="CTA-buttons">
                    <BackNavigation type={"CTA"} disabled={pending} />
                    {formLang.productType === 1 && (
                        <button
                            className="single-step__button single-step__button--order"
                            data-booking-flow-step="ltp-waitingListOverview"
                            disabled={
                                (error && error.errorType !== "updatedQuote") ||
                                pending ||
                                !termsAndConditions.selected ||
                                attachmentMissing
                            }
                            aria-busy={pending}
                            onClick={placeLtpOrderHandler}
                        >
                            {
                                waitingListFlowContext.localization
                                    .waitingListOverview.buttons.placeOrder
                            }
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default waitingListOverview;
